/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import useToggleClass from '../hooks/useToggleClass';

interface IWrapperProps {
  isSwiping: boolean;
  children: any;
}

const ClickableItemWrapper = (props: IWrapperProps) => {
  const wrapperRef = React.useRef<any>();
  const { isSwiping, children } = props;
  const { addClass, removeClass } = useToggleClass();

  React.useEffect(() => {
    isSwiping
      ? addClass('no-click', wrapperRef)
      : removeClass('no-click', wrapperRef);
  }, [isSwiping]);

  return <div ref={wrapperRef}>{children}</div>;
};

export default ClickableItemWrapper;
